import { AppData } from "../../game/AppData";
import { EventHandler } from "../../util/event/EventHandler";
import { WebUtil } from "../../util/web/WebUtil";
/**
 * WrapperLoader.ts
 */
export class WrapperLoader {
    constructor() {
        console.log("titan-game-upgrade: WrapperLoader");
    }
    load() {
        let url;
        let testConfig = WebUtil.getUrlParameter("testConfig");
        let cache = Date.now();
        if (testConfig == "local") {
            url = "test/so/so-wrapper.min.js";
        }
        else if (AppData.DEPLOY_TYPE.isNative() /*|| AppData.DEPLOY_TYPE.isNativeLite()*/) {
            url = AppData.VERSION + "/bin/so-wrapper.min.js";
        }
        else {
            url = window.location.origin + `/rgs/wrapper/so-wrapper.min.js?cache=` + cache.toString();
        }
        console.log("Wrapper URL: " + url);
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.head.appendChild(script);
        script.onload = this.handleScriptLoaded.bind(this);
        script.onerror = this.handleScriptFailed.bind(this);
    }
    onSuccess(handler, scope) {
        this.loadedHandler = new EventHandler(handler, scope);
    }
    onFailed(handler, scope) {
        this.failedHandler = new EventHandler(handler, scope);
    }
    handleScriptLoaded() {
        this.loadedHandler.call();
    }
    handleScriptFailed() {
        this.failedHandler.call();
    }
}
//# sourceMappingURL=WrapperLoader.js.map